export class GiftWrap {
  static init() {
    GiftWrap.bindEvents();

    const { itemsInCart, giftWrapsInCart, cartAttributes } =
      window.embark.shop.giftWrap;

    const totalItems = parseInt(itemsInCart) + parseInt(giftWrapsInCart);

    if (totalItems === 1 && giftWrapsInCart > 0) {
      GiftWrap.remove();
      return;
    }

    if (
      (giftWrapsInCart > 0 && itemsInCart !== giftWrapsInCart) ||
      (giftWrapsInCart > 0 && cartAttributes['gift-wrapping'] === 'no') ||
      (giftWrapsInCart === 0 && cartAttributes['gift-wrapping'] === 'yes')
    ) {
      GiftWrap.set();
    }
  }

  static bindEvents() {
    const giftWrapCheckbox = document.querySelector(
      '[name="attributes[gift-wrapping"]'
    );

    const giftWrapNote = document.querySelector(
      '[name="attributes[gift-note"]'
    );

    if (giftWrapCheckbox) {
      giftWrapCheckbox.addEventListener('change', (e) => {
        const { checked } = e.target;

        if (checked) {
          GiftWrap.set();
        } else {
          GiftWrap.remove();
        }
      });
    }

    if (giftWrapNote) {
      giftWrapNote.addEventListener('keyup', (event) => {
        if (event.target.value.length >= event.target.maxLength) {
          event.target.value = event.target.value.substring(
            0,
            event.target.maxLength
          );
          event.target.style.border = '2px solid #d20000';
        } else {
          event.target.style.border = '';
        }
      });
    }
  }

  static set() {
    const { productId, itemsInCart } = window.embark.shop.giftWrap;

    GiftWrap.update(productId, itemsInCart);
  }

  /**
   * Update the cart
   *
   * @param productId
   * @param quantity
   * @param giftWrapping
   */
  static update(productId, quantity, giftWrapping = 'yes') {
    void jQuery.post(
      '/cart/update.js',
      {
        updates: { [productId]: quantity },
        attributes: { 'gift-wrapping': giftWrapping },
      },
      (cart) => {
        GiftWrap.renderCart(cart);
      },
      'json'
    );
  }

  static remove() {
    const { productId } = window.embark.shop.giftWrap;

    GiftWrap.update(productId, 0, 'no');
  }

  /**
   *  Rerender the cart, after updates.
   *
   * @param _cart {{items_count, items: [], note, attributes: {}}}
   */
  static renderCart(_cart) {
    window.location.reload();
  }
}
